import getters from './getters';
import { createAuthURI, updateWindowLocationUrl } from './helpers';
import setupSessionMonitoring from './monitoring';

export const login = async () => {
	const url = await createAuthURI();
	updateWindowLocationUrl(url);
};

export const authorize = () => {
	if (getters.isAuthenticated) {
		const checkIntervalSec = 30;
		setupSessionMonitoring(checkIntervalSec);
	}
};



// WEBPACK FOOTER //
// ./src/sso-auth/authenticate.js